import {Button, Tooltip} from "@mui/material";
import AddIcon from '@mui/icons-material/Add';

export const customerPageHeaderRowSx = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
};

export const buttonCreateAutoSizeSx = {
    minWidth: "auto",
    minHeight: "unset",
    padding: "6px 12px",
};

const ButtonCreate = ({onClick, text, width = 210, height = 38, disabled = false, icon = true, tooltip, sx: sxProp}) => {
    const button = (
        <Button
            type="button"
            onClick={onClick}
            variant="outlined"
            disabled={disabled}
            sx={{
                width: width,
                height: height,
                borderRadius: "4px",
                color: (theme) => theme.palette.text.main,
                border: (theme) => `${theme.palette.primary.main} 1px solid`,
                padding: "8px",
            display: 'flex',
            gap: "8px",
            justifyContent: "flex-start",
            textTransform: 'none',
            fontFamily: (theme) => theme.typography.fontFamily,
            touchAction: 'manipulation',
                ...sxProp,
            }}
        >
            {icon && <AddIcon/>}
            {text}
        </Button>
    );

    if (!tooltip) {
        return button;
    }

    return (
        <Tooltip title={tooltip} placement="top" disableTouchListener>
            {disabled ? <span style={{display: 'block', width: '100%'}}>{button}</span> : button}
        </Tooltip>
    );
}
export default ButtonCreate